import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import styles from './styles';
import TextField from '../../normal/GeneralTextField';

const propTypes = {
  classes: PropTypes.shape({
    textLabel: PropTypes.string,
    textValue: PropTypes.string,
    textWrapper: PropTypes.string,
  }).isRequired,
  isEditing: PropTypes.bool.isRequired,
  initialValue: PropTypes.string,
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
  }).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool,
    invalid: PropTypes.bool,
  }).isRequired,
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  textValue: PropTypes.string,
};

const defaultProps = {
  initialValue: '',
  textValue: '',
};

const DateField = props => {
  const {
    classes,
    isEditing,
    initialValue,
    textValue,
    label,
    input: { value, onChange, onFocus },
    meta: { error, touched, invalid },
    id,
    ...otherProps
  } = props;

  const renderField = () => {
    if (isEditing) {
      return (
        <TextField
          {...otherProps}
          id={id}
          label={label}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          errMsg={error}
          invalid={invalid}
          touched={touched}
        />
      );
    }

    return (
      <div className={classes.textWrapper}>
        <div className={classes.textLabel}>{label}</div>
        <div className={classes.textValue} id={`${id}-text-value`}>
          {textValue || value}
        </div>
      </div>
    );
  };

  return <div>{renderField()}</div>;
};

DateField.propTypes = propTypes;
DateField.defaultProps = defaultProps;

export default withStyles(styles)(DateField);
